var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg42(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1500_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0637 11.2543H9.80376V16.2426L1.40142 24.2004L9.80376 32.1583V37.1096H15.0637L17.0084 38.9555L23.4969 45.0674L29.9546 38.9555L31.9363 37.1096H37.1654V32.1583L39.1471 30.3124L45.6048 24.2004L39.1471 18.0885L37.1654 16.2426V11.2543H31.9363L29.9546 9.40838L23.5031 3.29647L15.0637 11.2543ZM7.85906 9.41455H15.644L23.5031 2L31.3621 9.41455H39.1471V16.7612L47.0062 24.2066L39.1471 31.615V38.9616H31.356L23.5031 46.37L15.644 38.9555H7.85906V31.6088L0 24.2004L7.85906 16.755V9.41455ZM4.13017 24.2004L23.5031 5.3029L42.8328 24.2004L23.4969 42.8696L4.13017 24.2004Z",
    fill: "#006D58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1653 18.8417C35.0045 21.3482 32.0844 23.1695 28.9358 24.1387C27.2257 24.645 25.7935 24.8425 24.0154 24.9228C22.5893 24.9043 21.1138 25.1265 19.8482 25.8118C17.564 26.9909 15.9465 29.2196 15.8168 31.8249C15.6131 37.1343 20.268 38.6036 23.503 42.4806L29.1704 37.1157L37.1653 29.5283L42.8327 24.2005L37.1653 18.8417ZM9.80371 29.5283C11.9151 27.1947 14.6192 25.3673 17.6257 24.4042C20.9286 23.0707 23.7315 23.9288 26.4726 22.8669C28.7383 22.0273 30.5163 20.0024 31.0472 17.6379C32.0782 11.8346 27.1146 9.80968 23.4969 5.92028L17.8295 11.2481L9.80371 18.8294L4.13629 24.1943L9.80371 29.5283ZM1.40137 24.2005L9.80371 16.2426V11.2543H15.0637L23.503 3.29648L31.9424 11.2543H37.1653V16.2426L45.6047 24.2005L37.1653 32.1583V37.1096H31.9362L23.503 45.0736L15.0637 37.1096H9.80371V32.1583L1.40137 24.2005Z",
    fill: "#F1A400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1500_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg42);
export default __webpack_public_path__ + "static/media/42.88cd210156cc69862b1e1ebafcc0dc35.svg";
export { ForwardRef as ReactComponent };